import { Component, OnInit,  ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from "@angular/forms";
import { SavingsinstallmentchangeService } from "../savingsinstallmentchange/shared/savingsinstallmentchange.service";
import { Savings } from "../../savings/shared/savings.model";
import { SavingsService } from "../../savings/shared/savings.service";

@Component({
  selector: 'app-savingsinstallmentchange',
  templateUrl: './savingsinstallmentchange.component.html',
  styleUrls: ['./savingsinstallmentchange.component.css']
})
export class SavingsinstallmentchangeComponent implements OnInit {

  AddButtonText: string;
  ErrorText: string;
  InstallmentNo: number;
  readonlyTextBox: boolean = false;
  // LoanData$: any[] = [];
  savings = new Savings();

  DepositType : string;
  LoanPurpose : string;
  Address : string;
  Name : string;

  constructor(public savingsinstallmentchangeService: SavingsinstallmentchangeService,
    private savingsService: SavingsService,
    private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.InstallmentNo = +  params['Id'];
    });

    this.resetForm();
    this.readonlyTextBox =true;

    if (Number.isNaN(this.InstallmentNo)) {
      this.savingsinstallmentchangeService.selectedSavingsinstallmentchange.Id = 0;
      this.savingsinstallmentchangeService.selectedSavingsinstallmentchange.Flag = 1;
      this.savingsinstallmentchangeService.selectedSavingsinstallmentchange.IsActive = true;
      this.AddButtonText = "Save";
    }
    else {
      this.savingsinstallmentchangeService.selectedSavingsinstallmentchange.Id = +this.InstallmentNo;
      this.savingsinstallmentchangeService.selectedSavingsinstallmentchange.Flag = 2;
      this.savingsinstallmentchangeService.selectedSavingsinstallmentchange.IsActive = true;
      this.AddButtonText = "Edit & Save";
      this.getInstallmentchangeById();
    }
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.savingsinstallmentchangeService.selectedSavingsinstallmentchange = {
      Id: 0,
      SavingsId: null,
      InstallmentChangeDate: new Date().toString(),
      InstallmentAmount: null,
      InstallmentNo: 0,
      EmployeeId: null,
      EmployeeBranchId: null,
      CompanyId: null,
      SaasId: null,
      IsActive: null,
      Flag: 0
    }
  }

  onSubmit(form: NgForm) {

    if (this.savingsinstallmentchangeService.selectedSavingsinstallmentchange.SavingsId != null) {
      form.value.InstallmentNo = this.savingsinstallmentchangeService.selectedSavingsinstallmentchange.InstallmentNo;
      this.savingsinstallmentchangeService.IUDInstallmentChange(form.value)
        .toPromise()
        .then(data => {
          this.router.navigate(['/savingsinstallmentchangelist']);
        })
    }
  }

  getSavingsDeatils(SavingsId: any) {

    this.savings = new Savings();
    this.savings.Id = SavingsId;
    this.savings.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.savingsService.FetchSavingsById(this.savings)
      .toPromise()
      .then(data => {
        // console.log(data);        
        this.Address = data.Address;
        this.Name = data.CustomerName;
        this.savingsinstallmentchangeService.selectedSavingsinstallmentchange.InstallmentNo = data.TotalInstallmentCount;
        // this.DepositType = data.DepositTypeId;
        // this.LoanPurpose = data.TotalInstallmentCount;
      })
      .catch(err => { console.log(err) });
  }

  public ClickSearch(event: any) {
    // this.getInstallmentsList(this.savingsinstallmentchangeService.selectedSavingsinstallmentchange.LoanId);
    if (this.savingsinstallmentchangeService.selectedSavingsinstallmentchange.SavingsId != null) {
      this.getSavingsDeatils(this.savingsinstallmentchangeService.selectedSavingsinstallmentchange.SavingsId)
    }
  }

  getInstallmentchangeById(){
    this.savingsinstallmentchangeService.FetchInstallmentChangeById(this.savingsinstallmentchangeService.selectedSavingsinstallmentchange)
    .toPromise()
    .then(data => {

      this.savingsinstallmentchangeService.selectedSavingsinstallmentchange.Id = data.Id ;
      this.savingsinstallmentchangeService.selectedSavingsinstallmentchange.SavingsId = data.LoanId ;
      this.savingsinstallmentchangeService.selectedSavingsinstallmentchange.InstallmentChangeDate = data.InstallmentChangeDate  ;
      this.savingsinstallmentchangeService.selectedSavingsinstallmentchange.InstallmentAmount = data.InstallmentAmount ;
      this.savingsinstallmentchangeService.selectedSavingsinstallmentchange.InstallmentNo = data.InstallmentOption;
    })
  }

}
